import { ArticleHeading3, ArticleParagraph1, Image } from '@cian/ui-kit';
import { numberToPrettyString } from '@cian/utils';
import * as React from 'react';

import styles from './EtazhiBlackFridayPromoOfferCard.css';
import { UndergroundContainer, RailwayContainer, GeoBlock } from './components';
import { getOfferName } from './utils';
import { geoLabels as getGeoLabels } from './utils/geoLabels';
import { NBSP } from 'shared/constants/symbols';

import type { IOffer } from 'shared/offer';

export interface IEtazhiBlackFridayPromoOfferCardProps {
  onOfferClick(): void;
  offer: IOffer;
}

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export function EtazhiBlackFridayPromoOfferCard(props: IEtazhiBlackFridayPromoOfferCardProps) {
  const { offer, onOfferClick } = props;

  if (!offer) {
    return null;
  }

  const { bargainTerms, fullUrl, photos } = offer;

  const priceToDisplay = `${numberToPrettyString(bargainTerms.priceRur)}${NBSP}₽`;
  const photoCoverUrl = photos && photos.length ? photos[0].fullUrl : '';
  const title = getOfferName(offer);
  const geoLabels = getGeoLabels(offer);

  return (
    <div className={styles['container']}>
      <a
        href={fullUrl}
        target="_blank"
        rel="noreferrer"
        data-testid="EtazhiBlackFridayPromoOfferCard"
        className={styles['card']}
        onClick={onOfferClick}
      >
        <div className={styles['preview']}>
          <Image src={photoCoverUrl} objectFit="cover" height={140} borderRadius={0} />
        </div>
        <div className={styles['content']}>
          <span className={styles['price']}>
            <ArticleHeading3 as="h3" whiteSpace="nowrap">
              {priceToDisplay}
            </ArticleHeading3>
          </span>
          <div className={styles['title']}>
            <ArticleParagraph1 whiteSpace="nowrap">{title}</ArticleParagraph1>
          </div>
          <div data-testid="EtazhiBlackFridayPromoOfferCardGeo" className={styles['address']}>
            <GeoBlock geoLabels={geoLabels}>
              <UndergroundContainer offer={offer} />
              <RailwayContainer offer={offer} />
            </GeoBlock>
          </div>
        </div>
      </a>
    </div>
  );
}
